(function() {
  // Only one variant per product may be in the cart. The quick add buttons on product cards are rendered
  // with the cart state of the page load and are synced here when the cart changes without a reload
  // (adding via quick add, cart drawer) or the page comes back from the browser cache.
  function updateCartLocks() {
    fetch(window.routes.cart_url + '.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        const productIds = cart.items.map(function(item) {
          return String(item.product_id);
        });
        document.querySelectorAll('[data-cart-lock]').forEach(function(button) {
          const inCart = productIds.includes(button.dataset.cartLock);
          button.disabled = inCart;
          if(!inCart) {
            button.removeAttribute('aria-disabled');
          }
          const label = button.querySelector('span');
          if(label) {
            label.textContent = inCart ? button.dataset.labelInCart : button.dataset.label;
          }
        });
      })
      .catch(function(exception) {
        console.error('Error updating cart locks:', exception);
      });
  }

  if(typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateCartLocks);
  }

  window.addEventListener('pageshow', function(event) {
    if(event.persisted) {
      updateCartLocks();
    }
  });
})();
